import { AuthFormWrapper } from '../../authFormWrapper/index';
import authenticationOptions from './options';

/**
 * @description Signup Form
 * @type Component
 * @author Inderdeep
 */
export const SignUpForm = ({ type, login }) => {
  const { SignupForm, Options, title } = authenticationOptions[type] || {};
  const optionKeys = Object.keys(authenticationOptions);
  return (
    <AuthFormWrapper title={title || 'Sign Up'}>
      {SignupForm && <SignupForm />}
      {/* {optionKeys.length > 1 && (
        <div className="separator">
          <span className="line" />
          <span>OR CONTINUE WITH</span>
          <span className="line" />
        </div>
      )}
      <div className="links">
        {optionKeys.map((key) => {
          const { ButtonLink } = authenticationOptions[key];
          if (type === key) {
            return null;
          } else {
            return ButtonLink && <ButtonLink key={key} login={login} />;
          }
        })}
        <SocialSignin />
      </div> */}
      {Options && <Options />}
    </AuthFormWrapper>
  );
};
